interface Array<T> {
	moveToTop(o:T);
	moveToBottom(o:T);
	move(o:T, offset:number);
	remove(o:T);
}

Array.prototype.moveToTop = function (o) {
	let index = this.indexOf(o)
	this.splice(index, 1);
	this.unshift(o)
}

Array.prototype.moveToBottom = function(o) {
	let index = this.indexOf(o)
	this.splice(index, 1);
	this.push(o)
}

Array.prototype.move = function(o, offset) {
	let index = this.indexOf(o)
	if (index+offset < 0 || index+offset > this.length-1) return
	this.splice(index, 1);
	this.splice(index+offset, 0, o)
}

Array.prototype.remove = function(o) {
	let index = this.indexOf(o)
	this.splice(index);
}


// WEBPACK FOOTER //
// ./src/app/array.ts